(function () {
    'use strict';

    angular
        .module('financial')
        .config(FinancialRoute);

    FinancialRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function FinancialRoute ($stateProvider) {
        $stateProvider
            .state('root.financial', {
                abstract: true,
                url: '/financial',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state ('root.financial.revenue-cost', {
                url: '/report/revenue-cost',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/financial/report/revenue-cost/revenueCostReport.html',
                        controller: 'RevenueCostReportController',
                        controllerAs: 'revenueCostReportCtrl'
                    }
                }
            })
            .state ('root.financial.revenue', {
                url: '/report/revenue',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/financial/report/revenue/revenueReport.html',
                        controller: 'RevenueReportController',
                        controllerAs: 'revenueReportCtrl'
                    }
                }
            })
            .state ('root.financial.atm', {
                url: '/report/atm',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/financial/report/atm/atmReport.html',
                        controller: 'AtmReportController',
                        controllerAs: 'atmReport'
                    }
                }
            })
            .state ('root.financial.clientCredits', {
                url: '/report/client-credits',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/financial/report/client-credits/reportFilter.html',
                        controller: 'ClientCreditsController',
                        controllerAs: 'clientCredits'
                    }
                }
            });
            

    }
})();